<template>
  <v-card
    class="mx-auto parent-list-overflow rounded-card card-shadow"
    height="450"
    max-height="450"
  >
    <v-card-title class="headline text--primary font-weight-bold">
      Contratações de frete pendentes
    </v-card-title>
    <v-card-text class="text--primary list-overflow">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div>
        <v-list class="mt-3" v-if="!loading && contratacoes.length">
        <template v-for="contratacao in contratacoes">
          <v-list-item link :to="`contratacoes-fretes/${contratacao.id}`" :key="contratacao.id">
            <v-list-item-content>
              <v-row dense no-gutters>
                <v-col cols="12" sm="8">
                  <px-situacao-contratacao-frete-icon :situacao="contratacao.situacao"/>
                  {{ contratacao.transportadora.pessoa.nome }}
                </v-col>
                <v-col cols="12" sm="4" class="text-center">
                  {{ contratacao.total | currency }}
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="`div-${contratacao.id}`"/>
        </template>
      </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ContratacaoFreteService from '@/api/contratacao-frete-service';

export default {
  data() {
    return {
      loading: false,
      contratacoes: [],
    };
  },
  methods: {
    getContratacoes() {
      this.loading = true;
      ContratacaoFreteService.getConstratacoesList({
        query: 'situacao in ("PENDENTE_TRANSPORTADOR") order by createdIn desc',
      })
        .then(({ data }) => {
          this.contratacoes = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getContratacoes();
  },
};
</script>

<style scoped>
.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 395px;
  max-height: 395px;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
